import React from 'react';
import { connect } from 'react-redux';
import MiniCart from '../Components/MiniCart';
import { toggle } from '../Actions/Cart.action';
import { update as updateOrderRowQuantity } from '../Actions/Cart.action';
import { reloadPayment } from '../Actions/Checkout.action';
import { removeFromCartEvent } from '../Actions/Gtm.action';

const MiniCartContainer = props => (
    <MiniCart {...props} unitDecimalDigits={0} />
)

const mapStateToProps = state => {
    const { cart } = state;
    return {
        ...cart,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggle: () => dispatch(toggle()),
        updateOrderRowQuantity: (rowId, quantity, changeQuantity) => dispatch(updateOrderRowQuantity(rowId, quantity, changeQuantity))
            .then(() => {
                dispatch(reloadPayment());

            }),
        removeOrderRow: (rowId) => {
            return dispatch(removeFromCartEvent(rowId))
                .then(() => dispatch(updateOrderRowQuantity(rowId, 0, 0)))
                .then(() => {
                    dispatch(reloadPayment());
                })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniCartContainer);